/* tslint:disable */
/* eslint-disable */
/**
 * 80s Conservation Club REST API
 * 80s Conservation Club REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: graham@matthewsapps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Refresh Tokens Request Body
 * @export
 * @interface RefreshTokensRequest
 */
export interface RefreshTokensRequest {
    /**
     * User Sub
     * @type {string}
     * @memberof RefreshTokensRequest
     */
    sub: string;
    /**
     * Refresh Token
     * @type {string}
     * @memberof RefreshTokensRequest
     */
    refreshToken: string;
    /**
     * Device Key
     * @type {string}
     * @memberof RefreshTokensRequest
     */
    deviceKey?: string;
}

/**
 * Check if a given object implements the RefreshTokensRequest interface.
 */
export function instanceOfRefreshTokensRequest(value: object): value is RefreshTokensRequest {
    if (!('sub' in value) || value['sub'] === undefined) return false;
    if (!('refreshToken' in value) || value['refreshToken'] === undefined) return false;
    return true;
}

export function RefreshTokensRequestFromJSON(json: any): RefreshTokensRequest {
    return RefreshTokensRequestFromJSONTyped(json, false);
}

export function RefreshTokensRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RefreshTokensRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'sub': json['sub'],
        'refreshToken': json['refreshToken'],
        'deviceKey': json['deviceKey'] == null ? undefined : json['deviceKey'],
    };
}

export function RefreshTokensRequestToJSON(value?: RefreshTokensRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'sub': value['sub'],
        'refreshToken': value['refreshToken'],
        'deviceKey': value['deviceKey'],
    };
}

